<template>
	<div id="area_edu_index">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<dialog-table v-if="Visible" ref="dialog" @closeWin="closeWin"></dialog-table>
				<div v-on:click="screen()"><dv-decoration-9 :color="['#55ffff', '#0090ff']" class="full_screen">{{
					screenName }}</dv-decoration-9></div>
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">— {{ areaName }} —</span>
					</div>
				</div>
				<div class="body-box">
					<!-- 第四行数据开始 -->
					<div class="w-100 content-box">
						<div class="main_grid">
							<!-- 第一列 -->
							<div style="height: 90vh;">
								<div class="lr_block">
									<dv-border-box-13 :color="['#0575e6', '#0ad3f2']">
										<left1 @showBigEven="showBigEven(arguments)" />
									</dv-border-box-13>
								</div>
								<div class="lr_block">
									<dv-border-box-2 :color="['#0575e6', '#7766f2']">
										<left2 @showBigEven="showBigEven(arguments)" />
									</dv-border-box-2>
								</div>
								<!-- 左边 -->
								<div class="lr_block">
									<dv-border-box-8 :color="['#0575e6', '#815ef2']">
										<left3 />
									</dv-border-box-8>
								</div>
							</div>
							<!-- 第一列结束 -->
							<!-- 第二列 -->
							<div style="height: 90vh;">
								<!-- 上半部分 -->
								<div class="mt_block">
									<!-- 中间 -->
									<div class="campus_center w-100">
										<div class="flag"><img src="../../assets/img/flag.gif"></div>
										<div class="small_block01">
											<div class="block_txt">
												<div class="fw-b block_num color01">{{ deviceNum }}</div>
												<div class="title-item">设备总量</div>
											</div>
										</div>
										<div class="small_block02">
											<div class="block_txt">
												<div class="fw-b block_num color02">{{ teacherNum }}</div>
												<div class="title-item">教师总数</div>
											</div>
										</div>
										<div class="small_block03">
											<div class="block_txt">
												<div class="fw-b block_num color03">{{ studentNum }}</div>
												<div class="title-item">学生总数</div>
											</div>
										</div>
										<div class="small_block04">
											<div class="block_txt">
												<div class="fw-b block_num color04">{{ parentNum }}</div>
												<div class="title-item">家长总数</div>
											</div>
										</div>
										<div class="small_block05">
											<div class="block_txt">
												<div class="fw-b block_num color05">{{ clazzRoomNum }}</div>
												<div class="title-item">教室总数</div>
											</div>
										</div>
										<div class="small_block06">
											<div class="block_txt">
												<div class="fw-b block_num color06">{{ orgNum }}</div>
												<div class="title-item">学校总数</div>
											</div>
										</div>
										<div class="small_block07">
											<div class="block_txt">
												<div class="fw-b block_num color07">{{ recordRoomNum }}</div>
												<div class="title-item">录播教室</div>
											</div>
										</div>
									</div>
								</div>
								<!-- 上半部分结束 -->
								<!-- 下半部分 -->
								<div class="mb_block">
									<dv-border-box-1 :color="['#5f45c6', '#42a8c7']">
										<center2 />
									</dv-border-box-1>
								</div>
								<!-- 下半部分结束 -->
							</div>
							<!-- 第二列结束 -->
							<!-- 第三列开始 -->
							<div style="height: 90vh;">
								<div class="lr_block">
									<dv-border-box-13 :color="['#0575e6', '#0ad3f2']">
										<right1 @showBigEven="showBigEven(arguments)" />
									</dv-border-box-13>
								</div>
								<div class="lr_block">
									<dv-border-box-2 :color="['#0575e6', '#7766f2']">
										<right2 @showBigEven="showBigEven(arguments)" />
									</dv-border-box-2>
								</div>
								<div class="lr_block">
									<dv-border-box-8 :reverse="true" :color="['#0575e6', '#7c45f2']">
										<right3 @showBigEven="showBigEven(arguments)" />
									</dv-border-box-8>
								</div>
							</div>
							<!-- 第三列结束 -->
						</div>
					</div>
					<!-- 第四行数据结束 -->
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var region = storage.getItem("region");
var orgCode = storage.getItem("orgCode");
import left1 from "./left1";
import left2 from "./left2";
import left3 from "./left3";
import right1 from "./right1";
import right2 from "./right2";
import right3 from "./right3";
import center2 from "./center2";
import dialogTable from "./dialogTable";
export default {
	data() {
		return {
			loading: true,
			areaName: '',
			clazzRoomNum: 0,
			teacherNum: 0,
			studentNum: 0,
			parentNum: 0,
			deviceNum: 0,
			orgNum: 0,
			recordRoomNum: 0,
			fullscreen: false,
			screenName: "全屏",
			Visible: false
		};
	},
	components: {
		dialogTable,
		left1,
		left2,
		left3,
		right1,
		right2,
		right3,
		center2
	},
	mounted() {
		this.cancelLoading();
		this.initData();
		// 定时刷新时间
		let _this = this;
		// 定时器刷新，30分钟
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		showBigEven(data) {
			this.Visible = true;
			this.$nextTick(() => {
				this.$refs.dialog.initData(data[0], data[1]);
			})
		},
		closeWin() {
			this.Visible = false;
		},
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				_this.screenName = "全屏";
			} else {
				_this.screenName = "返回";
			}
			this.$http.get("/dataView/getNameByRedion?regionId=" + region).then(res => {
				if (res.data.code === 200) {
					_this.areaName = res.data.result + '教育局';
				}
			});
			this.$http.get("/dataView/edu/getAreaIndexInfo?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.clazzRoomNum = result.clazzRoomNum;
					_this.teacherNum = result.teacherNum;
					_this.studentNum = result.studentNum;
					_this.parentNum = result.parentNum;
					_this.deviceNum = result.deviceNum;
					_this.orgNum = result.orgNum;
					_this.recordRoomNum = result.recordRoomNum;
				}
			});
		},
		//点击全屏
		screen: function () {
			var type = this.$route.query.type;
			//判断访问客户端类型
			if (type == 'window') {
				let _this = this;
				let element = document.documentElement;
				if (_this.fullscreen) {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
					_this.screenName = "全屏";
				} else {
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					}
					_this.screenName = "取消";
				}
				_this.fullscreen = !_this.fullscreen;
			} else {
				//window.AndroidWebView.finish();
				this.$router.replace('/dataView/appIndex?area=' + region);
			}
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/areaIndexEdu.scss";

#area_edu_index {

	.title_bg {
		width: 100%;
		height: 10vh;
		background: url("../../assets/img/campusgensit_titbg.png") center no-repeat;
	}

	.title {
		width: 100%;
		text-align: center;

		.title-text {
			display: inline-block;
			font-size: 0.28rem !important;
			margin-top: 1.2rem;
			background-image: linear-gradient(135deg, #55ffff, #54c3ff);
			-webkit-background-clip: text;
			color: transparent;
		}
	}

	.small_block01,
	.small_block02,
	.small_block03,
	.small_block04,
	.small_block05,
	.small_block06,
	.small_block07 {
		width: 15%;
		height: 2rem;
		position: absolute;
		background: url("../../assets/img/campusgensit_icon.gif") center no-repeat;
		background-size: 80%;
	}

	.small_block01 {
		top: 4rem;
		left: 0.5rem;
	}

	.small_block02 {
		top: 2.8rem;
		left: 2.8rem;
	}

	.small_block03 {
		top: 2.8rem;
		right: 2.8rem;
	}

	.small_block04 {
		top: 4rem;
		right: 0.5rem;
	}

	.small_block05 {
		top: 5.2rem;
		left: 1.5rem;
	}

	.small_block06 {
		top: 1.5rem;
		left: 43.5%;
	}

	.small_block07 {
		top: 5.2rem;
		right: 1.5rem;
	}

	.color01 {
		color: #0d6efd !important;
	}

	.color02 {
		color: #20c997 !important;
	}

	.color03 {
		color: #717af1 !important;
	}

	.color04 {
		color: #25c2e3 !important;
	}

	.color05 {
		color: #dda6ff !important;
	}

	.color06 {
		color: #fd7e14 !important;
	}

	.color07 {
		color: #ffc107 !important;
	}

	.block_txt {
		text-align: center;
		font-size: 0.25rem;
		color: #35fff9;
	}

	.block_txt .block_num {
		font-size: 0.5rem;
		margin-bottom: 0.6rem;
	}

	.lr_block {
		margin: 0.1rem 0;
		height: 30vh;
	}

	.mt_block {
		height: 63vh;
		margin: 0 0.1rem;
	}

	.campus_center {
		width: 100%;
		height: 60vh;
		background: url("../../assets/img/campusgensit_sch.png") center 3.3rem no-repeat;
		position: relative;
	}

	.mb_block {
		height: 29vh;
		margin: 0 0.1rem;
	}

	.backbtn {
		position: absolute;
		right: 1.2rem;
		top: 0.25rem;
		display: inline-block;
		cursor: pointer;
		padding: 0.03rem 0.15rem;
		border-radius: 0.2rem;
		background-image: linear-gradient(135deg, #3d3370, #221f6f);
		color: #45c4ff;
		font-size: 0.18rem;
		z-index: 1;
	}

	.backbtn img {
		width: 0.18rem;
		vertical-align: middle;
	}

	.flag {
		width: 0.5rem;
		height: 0.5rem;
		position: absolute;
		top: 3rem;
		left: 50.5%;
	}

	.flag img {
		width: 100%;
	}
}</style>